import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5ff4dba0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "character-health-manage" }
const _hoisted_2 = { class: "character-health-manage__section" }
const _hoisted_3 = { class: "character-health-manage__hp-buttons" }
const _hoisted_4 = ["title"]
const _hoisted_5 = ["title"]
const _hoisted_6 = { class: "character-health-manage__section" }
const _hoisted_7 = { class: "character-health-manage__hp-buttons" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconButton = _resolveComponent("IconButton")!
  const _component_Icon = _resolveComponent("Icon")!
  const _component_Button = _resolveComponent("Button")!
  const _component_ModalWindow = _resolveComponent("ModalWindow")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_IconButton, {
      type: "ManaIcon",
      hint: _ctx.$t('manage-mana'),
      variant: "transparent",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.modal = true))
    }, null, 8, ["hint"]),
    _createVNode(_component_ModalWindow, {
      modelValue: _ctx.modal,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.modal) = $event)),
      title: _ctx.$t('manage-mana')
    }, {
      default: _withCtx(() => [
        _createElementVNode("article", _hoisted_1, [
          _createElementVNode("section", _hoisted_2, [
            _createElementVNode("h3", null, _toDisplayString(_ctx.$t("restore-or-spend-mana")) + ":", 1),
            _createElementVNode("label", null, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.value) = $event)),
                type: "number",
                min: "0",
                max: "999"
              }, null, 512), [
                [_vModelText, _ctx.value]
              ])
            ]),
            _createElementVNode("nav", _hoisted_3, [
              _createElementVNode("button", {
                title: _ctx.$t('restore'),
                class: "character-health-manage__hp-button",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.heal && _ctx.heal(...args)))
              }, [
                _createVNode(_component_Icon, { name: "Heal" })
              ], 8, _hoisted_4),
              _createElementVNode("button", {
                title: _ctx.$t('spend'),
                class: "character-health-manage__hp-button",
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.damage && _ctx.damage(...args)))
              }, [
                _createVNode(_component_Icon, { name: "Damage" })
              ], 8, _hoisted_5)
            ])
          ]),
          _createElementVNode("section", _hoisted_6, [
            _createElementVNode("h3", null, _toDisplayString(_ctx.$t("change-max-mana-modifier")) + ":", 1),
            _createElementVNode("label", null, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.modifier) = $event)),
                type: "number",
                min: "-999",
                max: "999"
              }, null, 512), [
                [_vModelText, _ctx.modifier]
              ])
            ]),
            _createElementVNode("nav", _hoisted_7, [
              _createVNode(_component_Button, {
                title: _ctx.$t('ui-apply'),
                onClick: _ctx.changeModifier
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("ui-apply")), 1)
                ]),
                _: 1
              }, 8, ["title", "onClick"])
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "title"])
  ], 64))
}